// extracted by mini-css-extract-plugin
module.exports = {"tabPanel":"TabPanel-module--tab-panel--3DCLp"};